<template>
  <div 
    class="  px-5 mt-9">
    <v-layout wrap>
      <v-flex>
        <section>
          
          <div class="color-dark-blue fs-20 font-weight-bold">
            Detail <span v-if="Object.keys(detail).length > 0">{{ detail.name }}</span>
          </div>

          <v-card flat class="pa-3 px-7 mt-3 border-radius-card">
            <div>
              <v-tabs
                v-model="tabs"
                dense
                background-color="transparent"
                slider-size="5"
                color="#6948c6">
                <v-tab
                  v-for="(item, index) in tab"
                  :key="index"
                  v-on:change="changeQuery(item.link)">
                  <span
                    class="body-2 font-weight-medium text-capitalize">
                    {{ item.title }}
                  </span>
                </v-tab>
              </v-tabs>
              <v-divider style="border-color: #EBEEF2;"></v-divider>
            </div>


            <div>

              <Profile v-if="tabs === 0"
                :detail="detail" @update="fetchDetail()" />

              <!-- <Visit v-if="tabs === 2" :detail="detail" /> -->

              <Customer v-if="tabs === 1" :detail="detail" />

              <Target v-if="tabs === 2" :detail="detail" />

              <Kunjungan v-if="tabs === 3" :detail="detail" />
            </div>
          </v-card>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              
              <v-btn
                to="/sales/staff"
                :disabled="process.form"
                color="red"
                elevation="0"
                width="140"
                height="45"
                class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                style="font-weight: 600;">
              
                  Kembali
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>
  
<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        tabs: 0,
        tab: [
          {
            title: 'Detail',
            link: `/sales/staff/detail/${this.$route.params.id}?menu=detail`
          },
          {
            title: 'Customer',
            link: `/sales/staff/detail/${this.$route.params.id}?menu=customer`
          },
          {
            title: 'Target Sales',
            link: `/sales/staff/detail/${this.$route.params.id}?menu=target`
          },
          {
            title: 'Target Kunjungan',
            link: `/sales/staff/detail/${this.$route.params.id}?menu=kunjungan`
          },
        ],


        detail: {},

        process: {
          load: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+93}, ${g+120}, ${b+12})`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.05)`
      },

      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },

      years () {
        let max = new Date().getFullYear()+2, min = max - 2, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      }
    },
    components: {
      Profile: () => import(/* webpackPrefetch: true */ '@/components/sales/profile.vue'),
      Customer: () => import(/* webpackPrefetch: true */ '@/components/sales/customer.vue'),
      Visit: () => import(/* webpackPrefetch: true */ '@/components/sales/visit.vue'),
      Target: () => import(/* webpackPrefetch: true */ '@/components/sales/target.vue'),
      Kunjungan: () => import(/* webpackPrefetch: true */ '@/components/sales/kunjungan.vue')
    },
    watch: {
      '$route.query.menu': function(val) {
        this.changeLink(val)
      }
    },
    mounted () {
      this.fetchDetail()
      this.changeLink(this.$route.query.menu)
    },
    methods: {
      async fetchDetail () {
        let params = {
            id: this.$route.params.id
          }
  
          await get('admin/user/detail', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.detail = res.results.data
          }
        })
      },

      changeLink (query) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
        
        if (query !== undefined) {
          this.tabs = query === 'detail' ? 0 : query === 'target' ? 2 : query === 'kunjungan' ? 3 : 1
        } else {
          this.tabs = 0
        this.$router.push(this.tab[this.tabs].link)
        }
      },
      changeQuery (link) {
        this.$router.push(link)
      },

      updateTime () {
        let cd = new Date()

        this.clock.time = this.zeroPadding(cd.getHours(), 2) + ':' + this.zeroPadding(cd.getMinutes(), 2) + ':' + this.zeroPadding(cd.getSeconds(), 2)
      },
      zeroPadding (num, digit) {
        let zero = ''

        for(let i = 0; i < digit; i++) {
          zero += '0'
        }
        return (zero + num).slice(-digit)
      }
    }
  }
</script>